import React, { useEffect, useState } from 'react';
import { IFtseConfiguration, useGetFtseConfigurationsQuery } from '../../generated/graphql';
import { Box } from '@mui/material';
import OverviewTable from '../Common/Tables/OverviewTable';
import { FormatTableData } from '../../utils/styleUtils';
import FtseConfigForm from './FtseConfigForm';

const FtseConfigList: React.FunctionComponent = () => {
  const { data, loading } = useGetFtseConfigurationsQuery();
  const [allData, setAllData] = useState<IFtseConfiguration[]>([]);
  const [ftseConfiguration, setFtseConfiguration] = useState<IFtseConfiguration | null>(null);
  const [openFtseConfigForm, setOpenFtseConfigForm] = useState(false);

  useEffect(() => {
    if (data && data.result) {
      setAllData(data.result as IFtseConfiguration[]);
    }
  }, [data]);

  const handleClose = () => {
    setOpenFtseConfigForm(false);
  };

  const handleDetails = (rowData: IFtseConfiguration) => {
    setFtseConfiguration(rowData);
    setOpenFtseConfigForm(true);
  };

  const columns = [
    {
      title: 'Details',
      width: 42,
      sorting: false
    },
    {
      title: 'Property Name',
      field: 'property',
      width: 792
    },
    {
      title: 'Property Value',
      field: 'value',
      width: 792
    }
  ];

  return (
    <Box className="overviewPage">
      <div className="print\:w-full"></div>
      <OverviewTable
        columns={columns}
        data={FormatTableData(allData)}
        loading={loading}
        handleDetails={handleDetails}
        handleRemove={() => true}
        pageSize={15}
        hideSearch
      />
      {openFtseConfigForm && (
        <FtseConfigForm
          handleClose={handleClose}
          ftseConfigurationInput={ftseConfiguration as IFtseConfiguration}
        />
      )}
    </Box>
  );
};

export default FtseConfigList;
